type Props = {
  items: {
    label: string;
    url: string;
  }[];
  tabActive: number;
};

export default function Tabs({ items, tabActive }: Props) {
  return (
    <nav className="tabs">
      <ul role="tablist">
        {items.map(({ label, url }, idx) => (
          <li key={idx}>
            <a href={url} className={tabActive === idx ? "active" : ""}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
